import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, tenantSlug) => {
    setError("");
    try {
      const slug = (tenantSlug ?? "").trim().toLowerCase();
      const { data } = await api.post("/auth/login", { email, password, tenant_slug: slug || null });
      if (data.access_token) localStorage.setItem("orbit_token", data.access_token);
      if (slug) localStorage.setItem("orbit_tenant", slug); else localStorage.removeItem("orbit_tenant");
      setUser(data.user);
      return data.user;
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
      return null;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("orbit_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, error, setError, login, logout, refresh, refreshUser: refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
